import { FC } from "react";
import { Button, Radio, Space } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useVesselStore } from "../store/vessel.store";
import { useShuttleStore } from "../store/shuttle.store";

export const Header: FC = () => {
  const { listState, setListState, openVesselModal } = useVesselStore();
  const { openShuttleModal } = useShuttleStore();
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-2xl font-semibold">Vessels & Shuttles</h2>
      <Space>
        <Radio.Group
          value={listState}
          onChange={(e) => setListState(e.target.value)}
        >
          <Radio.Button value="vessels">Vessels</Radio.Button>
          <Radio.Button value="shuttles">Shuttles</Radio.Button>
        </Radio.Group>
      </Space>
      <Space size="middle">
        <Button
          icon={<PlusOutlined />}
          className="flex items-center border-gray-300 hover:bg-gray-50"
          onClick={() =>
            (listState === "vessels" ? openVesselModal : openShuttleModal)()
          }
        >
          Add {listState === "vessels" ? "Vessel" : "Shuttle"}
        </Button>
        <Space size="small">
          <Button type="primary" className="bg-blue-500">
            List
          </Button>
          <Button className="border-gray-300 hover:bg-gray-50">Calendar</Button>
        </Space>
      </Space>
    </div>
  );
};
